export default __webpack_public_path__ + "static/Detox_Bar-2ca924caba6826a05b1bb9c0f9d11a4d.jpg";